export const PAYMENT_METHOD = {
	ONLINE: 'ONLINE',
	CASH_ON_DELIVERY: 'CASH_ON_DELIVERY',
};
